'use client';

import { SITE } from '@/app/constants';
import { CommunityEnum, RecommendSubTab } from '@/app/types';
import { FeedContainer } from '../_components/FeedContainer';
import { RecommendPageClient } from '../recommend/RecommendPageClient';

export const ShortFilmPageClient = () => {
  if (SITE === 'china') {
    return <RecommendPageClient activeSubTab={RecommendSubTab.ShortFilm} />;
  }

  return <FeedContainer exploreTab={CommunityEnum.ShortFilm} />;
};
